// Where the visitor came from (chat #5317): the campaign of the landing visit (utm_*, a click
// id) or, for a visit no campaign brought, the outside site that sent it. Read once when the
// app loads, kept for 30 days and sent with the contact form, so the lead on Wizzo's TODO
// board names its channel. A campaign replaces what is kept; a referrer never does.
const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'msclkid'];
const STORE = 'ws_attr';
const DAYS = 30;

function read(loc, referrer, storage, now) {
  let held = null;
  try {
    const kept = JSON.parse(storage.getItem(STORE) || 'null');
    if (kept && kept.a && now - kept.at < DAYS * 864e5) held = kept.a;
  } catch (err) { /* nothing kept */ }
  let next = null;
  try {
    const q = new URLSearchParams(loc.search);
    const found = {};
    KEYS.forEach((k) => {
      const v = (q.get(k) || '').trim().slice(0, 200);
      if (v) { found[k] = v; next = found; }
    });
    if (!next && !held && referrer) {
      const host = new URL(referrer).hostname.toLowerCase();
      const own = loc.hostname.toLowerCase().replace(/^www\./, '');
      if (host && host.replace(/^www\./, '') !== own && host.slice(-own.length - 1) !== '.' + own) next = { referrer: host };
    }
  } catch (err) { /* a bad referrer keeps what was held */ }
  if (next) {
    held = next;
    try { storage.setItem(STORE, JSON.stringify({ at: now, a: next })); } catch (err) { /* private mode */ }
  }
  return held || {};
}

let arrival = {};
try { arrival = read(window.location, document.referrer, window.localStorage, Date.now()); } catch (err) { /* no storage */ }

export { read };
export default arrival;
